module.exports = __webpack_public_path__ + "static/salon-pasajeros---asientos-afeba3df406f7aba7cfe634c6ecb21dc.jpg";